var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgPushPin = function SvgPushPin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 1 1",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.987.34.66.014a.044.044 0 0 0-.062 0L.383.227A.438.438 0 0 0 .059.32a.044.044 0 0 0-.003.066l.241.242-.286.286a.021.021 0 0 0-.006.013L0 .977A.021.021 0 0 0 .021 1h.002l.05-.005C.078.995.083.993.086.99L.372.703l.242.241A.044.044 0 0 0 .68.941.44.44 0 0 0 .773.617L.987.403a.044.044 0 0 0 0-.062ZM.705.55.672.582l.006.046a.346.346 0 0 1-.04.205l-.47-.47a.339.339 0 0 1 .204-.04l.046.004L.45.295.628.117l.255.255L.705.55Z",
    fill: "currentColor"
  })));
};

export default SvgPushPin;